// lib
import { identity, pluck, memoizeWith, slice, sort, values } from "ramda";

// color format: a200f1
const doDarken = (color) => {
  const percent = 5;
  // slice to remove # prefix
  const num = parseInt(color.slice(1), 16);
  const amt = Math.round(-2.55 * percent);
  /* eslint no-bitwise: 0 */
  const R = (num >> 16) + amt;
  const B = ((num >> 8) & 0x00ff) + amt;
  const G = (num & 0x0000ff) + amt;

  /* eslint no-nested-ternary: 0 */
  const hex = (
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
    (G < 255 ? (G < 1 ? 0 : G) : 255)
  )
    .toString(16)
    .slice(1);

  return `#${hex}`;
};

export const darken = memoizeWith(identity, doDarken);

export const DEFAULT_COLOR = "#888";
export const DEFAULT_MINE_COLOR = "#847894";
export const DEFAULT_LIGHT_COLOR = "#2D79A0";
export const COLORS = [
  "#2D79A0",
  "#009C60",
  "#EA8107",
  "#CE2F2B",
  "#4E4E4E",
  "#D7819E",
  "#24B9D7",
  "#5DCC5D",
  "#FFAF28",
  "#FD5956",
  "#807F79",
  "#007676",
  "#9C003C",
  "#A1542D",
  "#4C2D88",
];

const sortColors = ({ count: c1, index: i1 }, { count: c2, index: i2 }) => {
  if (c1 === c2) return i1 - i2;
  return c1 - c2;
};

// finds least used (according to presets) and coming first in COLORS
export const findBestColors = (number, usedColors) => {
  const colorIndex = COLORS.reduce(
    (acc, c, index) => ({ ...acc, [c]: { index, color: c, count: 0 } }),
    {},
  );
  for (const color of usedColors) {
    if (colorIndex[color]) colorIndex[color].count += 1;
  }
  return pluck("color", slice(0, number, sort(sortColors, values(colorIndex))));
};
